module.exports = __webpack_public_path__ + "static/media/Saint Jhn Roses Imanbek [Xsongspk.me].bcb1a3b3.mp3";